import { createReportViewModel as baseCreateReportViewModel } from '@hone-automation/common';
import { getCustomLabel } from './periods';
import { ReportViewModel } from './types';
import { Option } from 'types';
import { logger } from './utils';
import { Location as KsLocation } from '@hone-automation/common';
import { ReportConfiguration } from '@hone-automation/common/lib/Reports';

interface createReportViewModelProps {
  report: NestedHoneReport;
  reportId?: string;
  useComputedColumns?: boolean;
  periodReporting?: boolean;
  currentLocation?: KsLocation;
  reportCFG?: ReportConfiguration;
  periodTitles: Option[] | null;
  budget?: boolean;
  consolidated?: boolean;
}

export const createReportViewModel = ({
  report,
  useComputedColumns,
  currentLocation,
  periodTitles,
  budget = false,
  consolidated = false,
}: createReportViewModelProps): ReportViewModel | null => {
  if (!report || !currentLocation) {
    logger.error('(silent error) NT:createReportViewModel: Missing report or currentLocation');
    return null;
  }

  return baseCreateReportViewModel({
    report,
    useComputedColumns,
    consolidated,
    budget,
    getPeriodLabel: date => getCustomLabel(periodTitles, date),
  }) as ReportViewModel | null;
};
